import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'labArea_mng',
  components: {
    smartControlSel: function smartControlSel() {
      return import('../iot/smartControl/smartControl_sel');
    },
    feedBaitSel: function feedBaitSel() {
      return import('../iot/feeder/feedBait_sel');
    },
    videoSel: function videoSel() {
      return import('../iot/video/video_sel');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '养殖区域管理',
        addFunName: 'labAreaAdd',
        modifyFunName: 'labAreaModify',
        queryFunName: 'labAreaTree',
        detailFunName: 'labAreaDetail',
        delFunName: 'labAreaDel'
      },
      formData: {},
      rules: {
        name: [{
          required: true,
          message: '请输入养殖区域名称',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '请选择类别',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {}
      //   类别
      ,
      categoryOptions: [{
        value: 'Park',
        label: '园区'
      }, {
        value: 'Factory',
        label: '厂房'
      }, {
        value: 'Cistern',
        label: '养殖池'
      }, {
        value: 'Pond',
        label: '池塘'
      }, {
        value: 'Lake',
        label: '湖'
      }, {
        value: 'Ground',
        label: '地块'
      }],
      categoryObj: {
        Park: {
          label: '园区',
          icon: require('@/assets/org/Park.png')
        },
        Factory: {
          label: '厂房',
          icon: require('@/assets/org/Factory.png')
        },
        Cistern: {
          label: '养殖池',
          icon: require('@/assets/org/Cistern.png')
        },
        Pond: {
          label: '池塘',
          icon: require('@/assets/org/Pond.png')
        },
        Lake: {
          label: '湖',
          icon: require('@/assets/org/Lake.png')
        },
        Ground: {
          label: '地块',
          icon: require('@/assets/org/Ground.png')
        }
      }

      // 绑定设备
      ,
      smartControlSel_show: false,
      feedDeviceSel_show: false,
      videoSel_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    } // 选择检测设备
    ,
    smartControlSel: function smartControlSel(data) {
      console.log('smartControlSel', data);
      if (data) {
        this.$set(this.formData, 'smartControlId', data.id);
        this.$set(this.formData, 'smartControlName', data.name);
      }
      this.smartControlSel_show = false;
    } // 选择投饲设备
    ,
    feedBaitSel: function feedBaitSel(data) {
      if (data) {
        this.$set(this.formData, 'feedDeviceId', data.id);
        this.$set(this.formData, 'feedDeviceName', data.deviceName);
      }
      this.feedDeviceSel_show = false;
    } // 选择视频设备
    ,
    videoSel: function videoSel(data) {
      if (data) {
        this.$set(this.formData, 'videoId', data.id);
        this.$set(this.formData, 'videoName', data.videoName);
      }
      this.videoSel_show = false;
    },
    add: function add(data, node) {
      console.log('add', data, node);
      if (node.level == 1) {
        this.formData = {
          labId: data.id,
          labName: data.name,
          upperId: '19901001'
        };
      } else {
        this.formData = {
          labId: data.labId,
          labName: data.labName,
          upperId: data.id
        };
      }
      this.mapCenter = {
        lat: 39.908722,
        lng: 116.397499
      };
      this.markLocation = null;
      this.editDialogTitle = "\u300A ".concat(data.name, " \u300B\u65B0\u589E\u4E0B\u7EA7");
      this.editDialogShow = true;
    },
    edit: function edit(_ref) {
      var _this = this;
      var id = _ref.id;
      this.$api[this.pageConfig.detailFunName](id, {
        hasNames: true
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (res.data.lat && res.data.lng) {
                  _this.mapCenter = {
                    lat: res.data.lat,
                    lng: res.data.lng
                  };
                  _this.markLocation = {
                    lat: res.data.lat,
                    lng: res.data.lng
                  };
                }
                _this.initFormData(res.data);
                _this.editDialogTitle = "\u300A ".concat(res.data.name, " \u300B\u7F16\u8F91");
                _this.editDialogShow = true;
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    del: function del(_ref3) {
      var _this2 = this;
      var id = _ref3.id;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName]().then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    } // 百度地图
    ,
    getLocation: function getLocation(_ref4) {
      var point = _ref4.point;
      this.$set(this.formData, 'lon', point.lng);
      this.$set(this.formData, 'lat', point.lat);
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    }
  }
};